import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import DatatableUsers from "../../components/datatableUsers/DatatableUsers";

const ListUsers = ({columns}) => {
  return (
    <div className="list">
      <Sidebar/>
        <div className="listContainer">
            <Navbar/>
            <DatatableUsers columns={columns}/>
        </div>
    </div>
  )
}

export default ListUsers